import {BaseContainerModel} from '../base-container.model';
import { bl_mrp_job_order_hdr_RowClass } from '../../dbschema/bl_mrp_job_order_hdr.model';

export class MrpJobOrderHdrContainerModel extends BaseContainerModel {
  bl_mrp_job_order_hdr:  bl_mrp_job_order_hdr_RowClass = new  bl_mrp_job_order_hdr_RowClass();
}
